import React, { useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import './CaseStudy.css';

/**
 * Legacy deep link: /case-study/:id/tutorial
 * Resolves to the in-page Oxford Tutorial section after exhibit count is known.
 */
const CaseTutorialPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const params = new URLSearchParams();
    params.set('focus', 'tutorial');
    const next = searchParams.get('next');
    if (next) params.set('next', next);
    navigate(`/case-study/${id}?${params.toString()}`, { replace: true });
  }, [id, navigate, searchParams]);

  return (
    <div className="case-study-page">
      <div className="case-study-loading">Opening Oxford tutorial…</div>
    </div>
  );
};

export default CaseTutorialPage;
